import React from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import { useParams, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchRoutePlan } from "../api";
import RouteLoadSheetContent from "../components/Routes/RouteLoadSheetContent";
import styles from "./RouteLoadSheetPage.module.css";

export default function RouteLoadSheetPage() {
  const { planId } = useParams();
  const location = useLocation();
  const { data, isLoading, isError, error } = useQuery(
    ["routePlan", planId],
    async () => {
      const response = await fetchRoutePlan(planId);
      return response.data;
    },
    {
      enabled: Boolean(planId),
      staleTime: 60 * 1000,
    }
  );

  const [hasPrinted, setHasPrinted] = React.useState(false);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (data && params.get("print") === "1" && !hasPrinted) {
      setHasPrinted(true);
      setTimeout(() => window.print(), 200);
    }
  }, [data, location.search, hasPrinted]);

  if (isLoading) {
    return (
      <Box p={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !data?._id) {
    return (
      <Box p={4}>
        <Typography variant="h6" gutterBottom>
          Unable to load route sheet.
        </Typography>
        <Typography color="textSecondary">
          {error?.response?.data?.message || error?.message || "Unknown error."}
        </Typography>
      </Box>
    );
  }

  return (
    <div className={`${styles.pageRoot} route-printable`}>
      <RouteLoadSheetContent plan={data} showPrintButton />
    </div>
  );
}
